import React from 'react';
import { Col } from 'react-bootstrap';

const ProjectCard = ({ title, description, imgUrl, links }) => {
  return (
    <Col sm={6} md={4} className="mb-4">
      <div className="proj-imgbx">
        <img className="proimg" src={imgUrl} alt={title} />
        <div className="proj-txtx">
          <h4>{title}</h4>
          <span dangerouslySetInnerHTML={{ __html: description }} />
          <br />
          <a href={links} target="_blank" rel="noopener noreferrer" className="btn btn-primary btn-lg active" role="button" aria-pressed="true">LINK</a>
        </div>
      </div>
    </Col>
  );
}

export default ProjectCard;
